import { SVGProps } from "react";

export function IconThumbsUp(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.94904 1.01481C8.07944 1.54837 8.15359 2.07641 8.05131 2.75447C7.98313 3.2065 7.82306 3.88063 7.57112 4.77685H10.547C10.9792 4.78544 11.327 5.15356 11.327 5.64862C11.327 6.0099 11.1418 6.32185 10.8737 6.46771C11.2383 6.60087 11.5 6.96422 11.5 7.39158C11.5 7.82739 11.2279 8.19663 10.8519 8.32311C11.136 8.49229 11.327 8.80826 11.327 9.17012C11.327 9.70312 10.9125 10.1366 10.3968 10.1481C10.5435 10.2942 10.6352 10.5032 10.6352 10.7352C10.6352 11.1772 10.3022 11.4967 9.89151 11.4967C9.80678 11.4967 9.71747 11.4961 9.62909 11.4913L4.68302 11.2964C4.36405 11.2954 4.20457 10.9911 4.20457 10.3837C4.20457 9.47247 4.18507 6.19957 4.20457 5.82416C4.21756 5.57389 4.30716 5.3683 4.47336 5.20739C5.40773 4.29575 6.00594 3.53346 6.26798 2.92052C6.53002 2.30757 6.72851 1.67234 6.86344 1.01481C6.95672 0.671657 7.10718 0.500082 7.3148 0.500082C7.62624 0.500082 7.81863 0.481243 7.94904 1.01481ZM1.39937 5.16841H2.99057C3.48727 5.16841 3.88994 5.58248 3.88994 6.09325V10.5752C3.88994 11.0859 3.48727 11.5 2.99057 11.5H1.39937C0.902662 11.5 0.5 11.0859 0.5 10.5752V6.09325C0.5 5.58248 0.902662 5.16841 1.39937 5.16841Z"
        fill="black"
      />
    </svg>
  );
}
